import { useEffect } from 'react';
import { parse } from 'search-params';
import { useLocation } from 'react-router-dom';
import { useSessionStorage } from './useSessionStorage';

const useUTMQueryStrings = () => {
  const { search } = useLocation();
  const [, setUtmParams] = useSessionStorage('UTM_PARAMS');

  useEffect(() => {
    const paramsObj = parse(search);

    if (paramsObj) {
      const paramsKeys = Object.keys(paramsObj);

      if (paramsKeys.length) {
        const utmParams = paramsKeys
          .filter((paramKey) => paramKey.indexOf('utm_') === 0)
          .reduce((reduced, key) => {
            reduced[key] = paramsObj[key];

            return reduced;
          }, {});

        if (utmParams && Object.keys(utmParams).length) {
          setUtmParams(utmParams);
        }
      }
    }
  }, [search]);
};

export default useUTMQueryStrings;
